export enum City {
  PHANGAN = 'PHANGAN',
}
